import { Component } from '@angular/core';

@Component({
  selector: 'ngx-reviews-widget',
  templateUrl: './reviews-widget.component.html',
  styleUrls: ['./reviews-widget.component.scss']
})
export class ReviewsWidgetComponent {
  constructor(){}
}
